export enum DeleteReason {
	/** The pet has never visited the clinic that was added */
	PetNeverVisited,
	/** The vet clinic added was incorrect */
	AddedIncorrectClinic,
	/** The pet no longer visits this vet clinic */
	NoLongerVisits,
	Other,
}
